export default __webpack_public_path__ + "static/media/pontiac.a194ff6d.svg";